import React, { useEffect } from "react";

import { Provider } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";

import Routes from "routes";

import theme from "theme";
import { SnackbarProvider } from "notistack";
import { AuthProvider } from "hooks/useAuth";
import { initGA, getTrackingId } from "utils/analytics";
import { usePageTracking } from "hooks/useAnalytics";

import NavigationScroll from "components/NavigationScroll";
import { TourProvider } from "context/TourProvider";
import store from "./store";
// Import AOS CSS styles
import "aos/dist/aos.css";
// Component to initialize GA and track page views
const AnalyticsWrapper = ({ children }) => {
    useEffect(() => {
        // Initialize Google Analytics
        const trackingId = getTrackingId();
        if (trackingId) {
            initGA(trackingId);
        }
    }, []);

    // Track page views on route changes
    usePageTracking();

    return <>{children}</>;
};


const App = () => {
  return (
  
    <AuthProvider>
      <SnackbarProvider
        maxSnack={3}
        hideIconVariant
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        preventDuplicate
      >
        <Provider store={store}>
          {/* <SocketProvider> */}
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <AnalyticsWrapper>
              <TourProvider>
                <NavigationScroll>
                  <Routes />
                </NavigationScroll>
              </TourProvider>
            </AnalyticsWrapper>
          </ThemeProvider>
          {/* </SocketProvider> */}
        </Provider>
      </SnackbarProvider>
    </AuthProvider>
  );
};

export default App;
